<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <table class="table table-bordered table-hover table-sm no-bor">
                    <thead>
                        <tr>
                            <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                            <th>{{$t('year')}}</th>
                            <th class="text-right">{{$t('total_sale_amount')}}</th>
                            <th class="text-right">{{$t('total_sale_cost_amount')}}</th>
                            <th class="text-right">{{$t('total_sale_receipt_amount')}}</th>
                            <th class="text-right">{{$t('total_sale_return')}}</th>
                            <th class="text-right">{{$t('gross_profit')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ret, index) in records" :key="index" :class="{'bg-info':ret.Year==year}">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{ret.Year}}</td>
                            <td class="text-right">{{$money(ret.TotalAmount)}}</td>
                            <td class="text-right">{{$money(ret.TotalCost)}}</td>
                            <td class="text-right">{{$money(ret.TotalReceipt)}}</td>
                            <td class="text-right">{{$money(ret.TotalReturn)}}</td>
                            <td class="text-right">{{$money(ret.GrossProfit)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="2" class="text-right">{{$t('total')}}</th>
                            <th class="text-right">{{$money(summary.TotalAmount)}}</th>
                            <th class="text-right">{{$money(summary.TotalCost)}}</th>
                            <th class="text-right">{{$money(summary.TotalReceipt)}}</th>
                            <th class="text-right">{{$money(summary.TotalReturn)}}</th>
                            <th class="text-right">{{$money(summary.GrossProfit)}}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                year: new Date().getFullYear(),
                records: [],
                summary: {
                    TotalCost: 0,
                    TotalReceipt: 0,
                    GrossProfit: 0,
                    TotalAmount: 0,
                    TotalReturn: 0
                }
            }
        },
        created(){
            this.toList();
        },
        methods: {
            toList: function(){
                var loading = this.$loading.show();
                var req = {};
                this.$api().post('report/sale/yearly', req).then(res => {
                    if(this.$isValid(res)){
                        this.records = res.data.Json.Summaries;
                        this.calcualate();
                    }
                }).finally(function() { loading.hide(); });
            },
            calcualate(){
                var cost = 0;
                var receipt = 0;
                var gross_profit = 0;
                var total = 0;
                let sreturn = 0;
                this.records.map(el => {
                    cost += el.TotalCost;
                    receipt += el.TotalReceipt;
                    gross_profit += el.GrossProfit;
                    total += el.TotalAmount;
                    sreturn += el.TotalReturn;
                });
                
                this.summary.TotalCost = cost;
                this.summary.TotalReceipt = receipt;
                this.summary.GrossProfit = gross_profit;
                this.summary.TotalAmount = total;
                this.summary.TotalReturn = sreturn;
            }
        }
    }
</script>
